import { Component } from '@angular/core';
import { PortalAdminService } from './portaladmin.service';
import { AdminPermissions } from './admin-permissions-details';
import { ApiResponse } from "../../models/api-response";
import { NotificationService } from "../../services/notification.service";
import * as $ from "jquery";
import { UserDetails } from "./user-details";

@Component({
    selector: 'portaladmin',
    template: require('./portaladmin.component.html')
})

export class PortalAdmin {
    userLiveId: string;
    isRetrievalSuccess: boolean;
    permissions: Array<AdminPermissions>;
    selectedItems: Array<string>;
    isUserObjectId: boolean;
    userDetails: UserDetails;

    
    constructor(private portaladminservice: PortalAdminService, private notifier: NotificationService) {
        this.initializeCurrentTab();
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.isRetrievalSuccess = false;
        this.isUserObjectId = false;
        this.userLiveId = "";
    }

    viewPermissionsOfUser() {
        this.notifier.clear();
        this.isRetrievalSuccess = false;
        if (this.isInvalidLiveId(this.userLiveId)) return;
        
        this.notifier.displayInfo("Fetching...");
        this.portaladminservice.getAllPermissions(this.userLiveId)
            .subscribe(
                resp => {
                    this.permissions = (resp as ApiResponse).data as Array<AdminPermissions>;
                    this.isRetrievalSuccess = true;
                    this.notifier.displaySuccess("Successfully retrieved");
                },
                error => {
                    this.isRetrievalSuccess = false;
                    this.notifier.displayApiResponseError(error);
                });
    }

    getUserObjectId() {
        this.notifier.clear();
        this.isUserObjectId = false;
        if (this.isInvalidLiveId(this.userLiveId)) return;

        this.notifier.displayInfo("Fetching...");
        this.portaladminservice.getUserObjectId(this.userLiveId)
            .subscribe(
            resp => {
                let response = (resp as ApiResponse);
                
                if (response.statusCode == 200) {
                    this.userDetails = response.data;
                    this.isUserObjectId = true;
                    this.notifier.clear();
                } else {
                    this.notifier.displayError(response.data);
                }
            },
            error => {
                this.isRetrievalSuccess = false;
                this.notifier.displayError((error.statusCode !== 0) ? error.data : "server error");
            });
    }

    copyText(id: string) {
        $(`#${id}`).select();
        document.execCommand("copy");
    }

    isInvalidLiveId(val: string) {
        var regex = /^([\w\.\-]+)@([\w\-]+)((\.(\w)+)+)$/;
        if (val == null || val.trim() === "" || !regex.test(val)) {
            this.notifier.displayError("Please enter a valid Live Id");
            return true;
        }
        return false;
    }

    savePermissions() {
        this.notifier.clear();
        this.isRetrievalSuccess = false;
        this.notifier.displayInfo("Saving..");
        this.portaladminservice.savePermissions(this.userLiveId, this.permissions)
            .subscribe(resp => {
                    this.notifier.displaySuccess("Successfully Saved");
                },
                error => {
                    this.notifier.displayError((error.statusCode !== 0) ? error.data : "server error");
                });

    }

    
}


/** WEBPACK FOOTER **
 ** ./app/main/portalAdmin/portaladmin.component.ts
 **/